'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

WaypointType=function(){
function WaypointType(category,stopType,stopTitle,durationInHours){_classCallCheck(this,WaypointType);
this._category=category;
this._stopType=stopType;
this._stopTitle=stopTitle;
this._durationInHours=durationInHours;
}_createClass(WaypointType,[{key:'category',get:function()

{
return this._category;
}},{key:'stopType',get:function()

{
return this._stopType;
}},{key:'label',get:function()

{
let durationString=this.durationInHours<1?
`(${this.durationInHours*60} min)`:
`(${this.durationInHours} h)`;

return this._category!==null?
`${_.upperFirst(this._category)} - ${this._stopTitle} ${durationString}`:
this._stopTitle;
}},{key:'stopTitle',get:function()

{
return this._stopTitle;
}},{key:'durationInHours',get:function()

{
return this._durationInHours;
}}]);return WaypointType}();



const allWaypointTypes={
unselected:new WaypointType(null,'none','Not Selected',0),
load:new WaypointType('load','load','Live Load',2),
loadDropHook:new WaypointType('load','drophook','Drop and Hook',.75),
unload:new WaypointType('unload','unload','Live Load',2),
unloadDropHook:new WaypointType('unload','drophook','Drop and Hook',.75)};let




WaypointTypes=function(){function WaypointTypes(){_classCallCheck(this,WaypointTypes)}_createClass(WaypointTypes,null,[{key:'all',get:function()
{
return _.values(allWaypointTypes);
}},{key:'unselected',get:function()

{return allWaypointTypes.unselected}},{key:'load',get:function()
{return allWaypointTypes.load}},{key:'loadDropHook',get:function()
{return allWaypointTypes.loadDropHook}},{key:'unload',get:function()
{return allWaypointTypes.unload}},{key:'unloadDropHook',get:function()
{return allWaypointTypes.unloadDropHook}}]);return WaypointTypes}();




module.exports=WaypointTypes;
//# sourceMappingURL=waypointTypes.js.map
